import React from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Switch, Redirect } from 'react-router-dom'
import {
  ADMIN_DOWNLOADS_ROUTE as BASE_PATH,
  ADMIN_DOWNLOADS_ACCOUNTING_ROUTE,
} from 'utils/constants/admin'
import { Page, SubNav } from '../..'
import { AdminReports } from './AdminReports'

const AdminDocuments = () => {
  const { t } = useTranslation()

  const SUBPATHS = [
    {
      path: ADMIN_DOWNLOADS_ACCOUNTING_ROUTE,
      displayName: t('admin_documents.reports'),
    },
  ]

  return (
    <Page title={t('admin_documents.title')} testId="admin-documents-page">
      <SubNav paths={SUBPATHS} />
      <Switch>
        <Route exact path={ADMIN_DOWNLOADS_ACCOUNTING_ROUTE}>
          <AdminReports />
        </Route>
        <Redirect from={BASE_PATH} to={ADMIN_DOWNLOADS_ACCOUNTING_ROUTE} />
      </Switch>
    </Page>
  )
}

export { AdminDocuments }
